const Empresas = () => {
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-semibold text-gray-900">Empresas</h1>
        <p className="mt-1 text-sm text-gray-500">
          Gestiona las conexiones con empresas empleadoras y sus requisitos de contratación
        </p>
      </div>
    </div>
  );
};

export default Empresas; 